import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'filterText': '',
  'zoneData': {},
  'list': [],
  'filteredList': [],
};

const FORM_INITIAL_STATE = {
  'loading': false,
  'modificationDate': '',
  'values': {
    'code': null,
    'name': '',
    'lines': 1,
    'pickingTime': 1,
    'people': 1,
    'status': true,
    'locations': [],
  },
};

const filterList = (list, value) => {
  return [...list].filter((element) => {
    return (
      [
        element.name || '',
        element.lines.toString() || '',
        element.pickingTime.toString() || '',
        element.people.toString() || '',
        element.status ? 'Activo' : 'Inactivo',
      ].some((text) =>
        text.toLowerCase().includes(value.toLowerCase()) || value === ''
      )
    );
  });
};

export const zones = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_ZONES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ZONES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'filteredList': action.response.data,
    }),
    [ActionTypes.FETCHED_ZONES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'filteredList': [],
    }),
    [ActionTypes.FILTER_ZONES]: (state, action) => ({
      ...state,
      'filteredList': [...filterList(state.list, action.payload)],
    }),
    [ActionTypes.CHANGE_ZONES_TEXT_FILTER]: (state, action) => ({
      ...state,
      'filterText': action.payload,
    }),
  })(state, action);
};

export const zone = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_ZONE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ZONE]: (state, action) => ({
      ...state,
      'loading': false,
      'zoneData': action.response.data,
    }),
    [ActionTypes.FETCHED_ZONE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'zoneData': {},
    }),
  })(state, action);
};

export const zoneForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.FETCHING_ZONE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ZONE]: (state, action) => ({
      ...state,
      'loading': false,
      'modificationDate': action.response.data.modificationDate,
      'values': {
        'name': action.response.data.name,
        'lines': action.response.data.lines,
        'pickingTime': action.response.data.pickingTime,
        'people': action.response.data.people,
        'status': action.response.data.status,
        'locations': action.response.data.locations || [],
      },
    }),
    [ActionTypes.FETCHED_ZONE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'modificationDate': '',
      'values': {
        'code': null,
        'name': '',
        'lines': 1,
        'pickingTime': 1,
        'people': 1,
        'status': true,
        'locations': [],
      },
    }),
    [ActionTypes.CHANGE_ASSIGNED_LOCATIONS]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'locations': action.payload,
      },
    }),
  })(state, action);
};
